export default "__VITE_ASSET__4b5e44c6__"